import React from 'react';
import styled from 'styled-components';
import HowToRead, { SectionShell, Grid, Cell, HeadCell } from './HowToRead';
import DistributionBar from './DistributionBar';
import { formatPct, formatMean, scaleLegend } from '../reportModel';
import { DISTRIBUTION_COLORS } from '../reportPalette';

const COLS = 'minmax(160px, 1.2fr) minmax(160px, 2fr) 70px 60px';

const Legend = styled.div`
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.report.muted};
  span::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 6px;
    border-radius: 2px;
    background: var(--c);
  }
`;

const DimRow = styled(Cell)`
  background: ${({ theme }) => theme.colors.report.panel};
  padding-left: 10px;
  padding-right: 10px;
`;

export function ScaleLegend({ t, method }) {
  const l = scaleLegend(t, method);
  return (
    <Legend data-testid="scale-legend">
      <span style={{ '--c': DISTRIBUTION_COLORS.unfavorable }}>{l.unfavorable}</span>
      {l.neutral && <span style={{ '--c': DISTRIBUTION_COLORS.neutral }}>{l.neutral}</span>}
      <span style={{ '--c': DISTRIBUTION_COLORS.favorable }}>{l.favorable}</span>
    </Legend>
  );
}

function Row({ item, t, lang, bold }) {
  const C = bold ? DimRow : Cell;
  return (
    <>
      <C $bold={bold}>{item.name}</C>
      <C>{item.insufficient ? null : <DistributionBar result={item} />}</C>
      <C $bold $align="right">{item.insufficient ? t('survey.report.insufficientCell') : formatPct(t, item.favorablePct)}</C>
      <C $align="right" $muted>{item.insufficient ? '' : formatMean(item.mean, lang)}</C>
    </>
  );
}

export default function DimensionResults({ data, t, lang }) {
  // Son inceleme I2 — bölümsüz (ve dal öncesi yapısız) ankette boş başlık tablosu çizilmez.
  if (!data.dimensions?.length) return null;
  return (
    <SectionShell id="s02" title={t('survey.report.section.s02')} actions={<ScaleLegend t={t} method={data.method} />}>
      <HowToRead t={t}>{t('survey.report.help.dimensions')}</HowToRead>
      <Grid $cols={COLS}>
        <HeadCell>{t('survey.report.colSubDimension')}</HeadCell>
        <HeadCell>{t('survey.report.colDistribution')}</HeadCell>
        <HeadCell $align="right">{t('survey.report.colFavorable')}</HeadCell>
        <HeadCell $align="right">{t('survey.report.colMean')}</HeadCell>
        {data.dimensions.map((d) => (
          <React.Fragment key={d.id}>
            <Row item={d} t={t} lang={lang} bold />
            {(d.subDimensions || []).map((s) => <Row key={s.id} item={s} t={t} lang={lang} />)}
          </React.Fragment>
        ))}
      </Grid>
    </SectionShell>
  );
}
